import {Controller} from "stimulus"
import $ from 'jquery';

require("select2/dist/css/select2")
require("select2-bootstrap-theme/dist/select2-bootstrap")
import select2 from "select2"
import bootbox from "bootbox";
import {get} from '@rails/request.js'
import flatpickr from "flatpickr";
import {Spanish} from "flatpickr/dist/l10n/es";

export default class extends Controller {
    static targets = ["form", "agency", "office", "dropOffice", "dateFrom", "dateTo"]

// Propiedades para controlar las ejecuciones
    debounceTimer = null
    lastExecutionTime = 0
    minExecutionInterval = 1000
    pendingExecution = false
    currentFormState = ''
    lastExecutedValues = ''  // <--- Esta es importante
    fieldChangeTimer = null
    dropOffDateRequest = null
    productsRequest = null
    lastFieldValues = {}
    dropOffDateController = null
    productsController = null

    initialize() {
        let context = this;
        // Declarar los select2
        if (this.hasDropOfficeTarget) {
            $(this.dropOfficeTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una opción"
            }).prop('disabled', true)
        }

        if (this.hasOfficeTarget) {
            let pickup_office = $(this.officeTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una opción"
            }).prop('disabled', true).on('change.select2', () => {
                context.getOfficeDetails()
                console.log($('vehicles_area'))

                if (!context.officeTarget.value.isEmpty()) {
                    $(context.dropOfficeTarget).removeAttr('disabled')
                } else {
                    $(context.dropOfficeTarget).empty()
                    $(context.dropOfficeTarget).prop('disabled', true)
                }

            })

        }


        if (this.hasAgencyTarget) {
            let agencySelect2 = $(this.agencyTarget).select2({
                theme: "bootstrap",
                language: "es",
                placeholder: "Seleccione una opción",
                allowClear: true
            }).on('change.select2', () => {
                $('#current_agency').html(context.agencyTarget.selectedOptions[0].text)
                if (!context.agencyTarget.value.isEmpty()) {
                    $(context.officeTarget).removeAttr('disabled')
                    $(context.officeTarget).empty();
                    context.getOffice()
                } else {
                    $(context.officeTarget).empty()
                    $(context.officeTarget).prop('disabled', true)
                }
            })

            if (this.agencyTarget.dataset.value !== undefined && !this.agencyTarget.dataset.value.isEmpty()) {
                agencySelect2.val(this.agencyTarget.dataset.value).trigger({
                    type: 'change.select2'
                });
            }

        }


        // Inicializar el sistema de detección de campos completos
        this.initFormCompletionDetection();
    }

    connect() {

    }

    initFormCompletionDetection() {
        // Estado de los campos requeridos
        this.requiredFields = {
            agency: false,
            office: false,
            dropOffice: false,
            dateFrom: false,
            dateTo: false
        };

        // Crear observers para TODOS los campos
        this.createAllObservers();

        // Hacer una primera verificación por si algunos campos ya tienen valor
        setTimeout(() => {
            this.checkAllFieldsInitial();
        }, 500);
    }

    createAllObservers() {
        // Observer para agency
        if (this.hasAgencyTarget) {
            this.createFieldObserver('agency', this.agencyTarget);
        }

        // Observer para office
        if (this.hasOfficeTarget) {
            this.createFieldObserver('office', this.officeTarget);
        }

        // Observer para dropOffice
        if (this.hasDropOfficeTarget) {
            this.createFieldObserver('dropOffice', this.dropOfficeTarget);
        }

        // Observer para dateFrom (input de flatpickr)
        if (this.hasDateFromTarget) {
            this.createFieldObserver('dateFrom', this.dateFromTarget);
        }

        // Observer para dateTo (input de flatpickr)
        if (this.hasDateToTarget) {
            this.createFieldObserver('dateTo', this.dateToTarget);
        }
    }

    createFieldObserver(fieldName, element) {
        const observer = new MutationObserver((mutations) => {
            let shouldCheck = false;

            mutations.forEach((mutation) => {

                if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                    shouldCheck = true;
                }

                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // Cuando se agregan nuevas opciones al select
                    shouldCheck = true;
                }

                if (mutation.type === 'subtree' && mutation.target.tagName === 'OPTION') {
                    // Cuando cambian las opciones existentes
                    shouldCheck = true;
                }
            });

            if (shouldCheck) {
                this.checkFieldValue(fieldName);
            }
        });

        // Configurar el observer para observar múltiples aspectos
        observer.observe(element, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['value', 'selected', 'disabled']
        });

        // Guardar referencia al observer
        if (!this.observers) this.observers = {};
        this.observers[fieldName] = observer;

        // También agregar event listeners para cambios programáticos
        this.addProgrammaticChangeListener(fieldName, element);
    }

    addProgrammaticChangeListener(fieldName, element) {
        // Para cambios que puedan venir de jQuery/select2/flatpickr
        const eventTypes = ['change', 'select2:select', 'flatpickr:change', 'input'];

        eventTypes.forEach(eventType => {
            $(element).on(eventType, () => {
                setTimeout(() => this.checkFieldValue(fieldName), 50);
            });
        });
    }

    checkFieldValue(fieldName) {
        const field = this[`${fieldName}Target`];
        if (!field) return false;

        let hasValue = false;
        let currentValue = null;

        // Obtener valor según el tipo de campo
        if (field.tagName === 'SELECT') {
            // Para selects (agency, office, dropOffice)
            if (field.selectedOptions && field.selectedOptions.length > 0) {
                currentValue = field.selectedOptions[0].value;
                hasValue = currentValue && currentValue.toString().trim() !== '' && currentValue !== 'null';
            } else {
                currentValue = field.value;
                hasValue = currentValue && currentValue.toString().trim() !== '' && currentValue !== 'null';
            }
        } else {
            // Para inputs (dateFrom, dateTo)
            currentValue = field.value;
            hasValue = currentValue && currentValue.toString().trim() !== '';
        }

        // SIEMPRE actualizar el estado, independientemente de si cambió o no
        const oldValue = this.requiredFields[fieldName];
        this.requiredFields[fieldName] = hasValue;

        // Registrar SOLO si el valor o el estado cambió
        if (oldValue !== hasValue || currentValue !== this.lastFieldValues?.[fieldName]) {
            console.log(`Campo ${fieldName}: ${hasValue ? '✓' : '✗'} (${currentValue})`);
        }

        // Guardar el último valor del campo para comparar
        if (!this.lastFieldValues) this.lastFieldValues = {};
        this.lastFieldValues[fieldName] = currentValue;

        // SIEMPRE verificar si todos están completos después de CADA cambio
        // Pero con un pequeño delay para evitar múltiples llamadas
        clearTimeout(this.fieldChangeTimer);
        this.fieldChangeTimer = setTimeout(() => {
            console.log(`⏱ Verificando después de cambio en ${fieldName}`);
            this.checkAllFieldsComplete();
        }, 150);

        return hasValue;
    }

    checkAllFieldsInitial() {
        console.log('Verificando estado inicial de los campos...');
        Object.keys(this.requiredFields).forEach(fieldName => {
            this.checkFieldValue(fieldName);
        });
    }

    checkAllFieldsComplete() {
        const allComplete = Object.values(this.requiredFields).every(value => value === true);

        // Crear un identificador único del estado actual del formulario
        const currentState = this.getFormStateString();

        if (allComplete) {
            console.log('✅ TODOS LOS CAMPOS COMPLETOS - Programando ejecución');

            // Si el estado no ha cambiado, no hacer nada
            if (this.currentFormState === currentState) {
                console.log('El estado del formulario no ha cambiado, ignorando...');
                return;
            }

            // Actualizar el estado actual
            this.currentFormState = currentState;

            // Cancelar cualquier ejecución pendiente
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }

            // Programar la ejecución con debounce
            this.debounceTimer = setTimeout(() => {
                this.executeWithThrottle();
            }, 500); // Esperar 500ms después del último cambio

        } else {
            const incomplete = this.getIncompleteFields();
            console.log('⏳ Esperando campos:', incomplete.join(', '));
            // Resetear el estado cuando hay campos incompletos
            this.currentFormState = '';
        }
    }

    //Obtener un string único del estado del formulario
    getFormStateString() {
        return `${this.getSelectValue(this.agencyTarget)}_${this.getSelectValue(this.officeTarget)}_${this.getSelectValue(this.dropOfficeTarget)}_${this.dateFromTarget?.value}_${this.dateToTarget?.value}`;
    }

    // Ejecutar con throttling
    executeWithThrottle() {
        const now = Date.now();
        const timeSinceLastExecution = now - this.lastExecutionTime;

        if (timeSinceLastExecution >= this.minExecutionInterval) {
            // Podemos ejecutar ahora
            console.log('🎯 Ejecutando getProducts (throttle pasado)');
            this.getProducts();
            this.lastExecutionTime = now;
        } else {
            // Muy pronto, programar para después
            console.log(`⏰ Demasiado pronto, esperando ${this.minExecutionInterval - timeSinceLastExecution}ms`);

            if (!this.pendingExecution) {
                this.pendingExecution = true;
                setTimeout(() => {
                    this.pendingExecution = false;
                    this.executeWithThrottle();
                }, this.minExecutionInterval - timeSinceLastExecution);
            }
        }
    }

    getIncompleteFields() {
        return Object.entries(this.requiredFields)
            .filter(([_, isComplete]) => !isComplete)
            .map(([field]) => field);
    }

    // Helper para obtener valor de select de manera segura
    getSelectValue(selectElement) {
        if (!selectElement) return null;

        if (selectElement.selectedOptions && selectElement.selectedOptions.length > 0) {
            return selectElement.selectedOptions[0].value;
        }
        return selectElement.value;
    }

    validateValues(agency, office, office_drop, from_date, to_date) {
        if (!agency || agency === 'null' || agency === '') {
            console.log('❌ Agencia no válida:', agency);
            return false;
        }
        if (!office || office === 'null' || office === '') {
            console.log('❌ Oficina no válida:', office);
            return false;
        }
        if (!office_drop || office_drop === 'null' || office_drop === '') {
            console.log('❌ Oficina de drop no válida:', office_drop);
            return false;
        }
        if (!from_date || from_date.trim() === '') {
            console.log('❌ Fecha desde no válida:', from_date);
            return false;
        }
        if (!to_date || to_date.trim() === '') {
            console.log('❌ Fecha hasta no válida:', to_date);
            return false;
        }
        return true;
    }

    executeGetProducts() {
        this.checkAllFieldsComplete();
    }


    getOffice() {
        let office = this.officeTarget
        let agency = this.agencyTarget.selectedOptions[0].value;
        let target = office.id
        let checked = ''
        if (this.officeTarget.dataset.value !== undefined && !this.officeTarget.dataset.value.isEmpty()) {
            checked = office.dataset.value
        }


        get(`/admin/get_offices_b2c`, {
            query: {
                agency: agency,
                target: target,
                checked: checked
            },
            responseKind: "turbo-stream"
        }).then(r => {
            this.setOffice()
        })
    }

    setOffice() {
        if (this.officeTarget.dataset.value !== undefined && !this.officeTarget.dataset.value.isEmpty()) {
            // Usar MutationObserver para detectar cuando las opciones se han cargado
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                        // Verificar si el valor existe entre las opciones
                        const optionExists = Array.from(this.officeTarget.options).some(
                            option => option.value === this.officeTarget.dataset.value
                        );

                        if (optionExists) {
                            $(this.officeTarget).val(this.officeTarget.dataset.value);
                            $(this.officeTarget).trigger({
                                type: 'change.select2'
                            });

                            // Verificar office después de setear
                            setTimeout(() => {
                                this.checkFieldValue('office');
                            }, 100);

                            observer.disconnect();
                        }
                    }
                });
            });

            observer.observe(this.officeTarget, {
                childList: true,
                subtree: true
            });
        }
    }

    getOfficeDetails() {
        let agency = this.agencyTarget.selectedOptions[0].value;
        console.log(this.officeTarget.selectedOptions[0])
        let office = this.officeTarget.selectedOptions[0].value;
        let target = 'office_details'
        let checked = ''
        if (this.dropOfficeTarget.dataset.value !== undefined && !this.dropOfficeTarget.dataset.value.isEmpty()) {
            checked = this.dropOfficeTarget.dataset.value
        }

        get(`/admin/get_office_details`, {
            query: {
                agency: agency,
                office: office,
                target: target,
                checked: checked
            },
            responseKind: "turbo-stream"
        }).then(r => {
            if (r.response.status === 200) {
                // Observer para detectar cuando se carga dropOffice
                if (this.hasDropOfficeTarget) {
                    const dropOfficeObserver = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                                setTimeout(() => {
                                    // Si hay un valor por defecto en dataset
                                    if (this.dropOfficeTarget.dataset.value &&
                                        this.dropOfficeTarget.dataset.value !== '') {
                                        $(this.dropOfficeTarget).val(this.dropOfficeTarget.dataset.value)
                                            .trigger('change');
                                    }
                                    // Verificar el valor después de cargar
                                    this.checkFieldValue('dropOffice');
                                }, 100);
                            }
                        });
                    });

                    dropOfficeObserver.observe(this.dropOfficeTarget, {
                        childList: true,
                        subtree: true
                    });
                }

                this.setPickUpDates();
            }
        })
    }

    setPickUpDates() {
        let context = this;
        let agency = this.agencyTarget.selectedOptions[0].value;
        let office = this.officeTarget.selectedOptions[0].value;

        get(`/admin/get_offices_dates_b2c`, {
            query: {
                agency: agency,
                office: office
            },
            responseKind: "json"
        }).then(r => {
            r.json.then((data) => {
                if (data.success) {
                    let data_date = data.data
                    console.log(data_date)
                    $(this.dateFromTarget).removeAttr('disabled');
// Destruir flatpickr anterior si existe
                    if (this.dateFromTarget._flatpickr) {
                        this.dateFromTarget._flatpickr.destroy();
                    }

                    // Determinar la fecha por defecto
                    let defaultDateValue;
                    console.log('Buscar valor por defecto')
                    console.log(!this.dateToTarget.dataset.value.isEmpty())
                    console.log(data_date.min_length_reservation)
                    if (!this.dateFromTarget.dataset.value.isEmpty()) {
                        // Si hay un valor por defecto en data-atributo
                        defaultDateValue = this.dateFromTarget.dataset.value;
                    } else {
                        // Usar la fecha mínima de reserva
                        defaultDateValue = data_date.min_length_reservation;
                    }

                    const fp = flatpickr(`#${this.dateFromTarget.id}`, {
                        altInput: true,
                        enableTime: true,
                        altFormat: "d/m/Y H:i",
                        dateFormat: "d/m/y H:i",
                        defaultDate: defaultDateValue,
                        minDate: `${data_date.min_length_reservation}`,
                        maxDate: `${data_date.max_length_reservation}`,
                        disable: data_date.disabled_date,
                        disableMobile: "true",
                        minuteIncrement: 15,
                        locale: Spanish,
                        onChange: function (selectedDates, dateStr, instance) {
                            console.log('DateFrom onChange:', dateStr);
                            setTimeout(() => {
                                context.setDropOffDate();
                            }, 100)


                            // Usar requestAnimationFrame para evitar múltiples llamadas
                            requestAnimationFrame(() => {
                                context.checkFieldValue('dateFrom');
                            });
                        }
                    });
                    // Usar requestAnimationFrame para la verificación inicial
                    requestAnimationFrame(() => {
                        context.checkFieldValue('dateFrom');
                    });
                    fp.setDate(defaultDateValue, true)

                } else {
                    toastr.error(data.message);
                }
            })
        })
    }

    setDropOffDate() {
        let context = this;
        let agency = this.agencyTarget.selectedOptions[0].value;
        let office = this.officeTarget.selectedOptions[0].value;
        let pickup = this.dateFromTarget.value;

        // Cancelar petición anterior si existe
        if (this.dropOffDateRequest) {
            this.dropOffDateController.abort();
        }

        this.dropOffDateController = new AbortController();

        this.dropOffDateRequest = get(`/admin/get_offices_dates_b2c`, {
            query: {
                agency: agency,
                office: office,
                pickup: pickup
            },
            responseKind: "json"
        }).then(r => {
            r.json.then((data) => {
                if (data.success) {
                    let data_date = data.data
                    console.log(data_date)
                    $(this.dateToTarget).removeAttr('disabled');

                    // Destruir flatpickr anterior si existe
                    if (this.dateToTarget._flatpickr) {
                        console.log('Destriur flatpicker')
                        this.dateToTarget._flatpickr.destroy();
                    }

                    // Determinar la fecha por defecto
                    let defaultDateValue;
                    console.log('Buscar valor por defecto')
                    console.log(!this.dateToTarget.dataset.value.isEmpty())
                    console.log(data_date.min_length_reservation)
                    if (!this.dateToTarget.dataset.value.isEmpty()) {
                        // Si hay un valor por defecto en data-atributo
                        defaultDateValue = this.dateToTarget.dataset.value;
                    } else {
                        // Usar la fecha mínima de reserva
                        defaultDateValue = data_date.min_length_reservation;
                    }

                    console.log('📅 Fecha por defecto dropoff:', defaultDateValue);

                    flatpickr(`#${this.dateToTarget.id}`, {
                        altInput: true,
                        enableTime: true,
                        altFormat: "d/m/Y H:i",
                        dateFormat: "d/m/y H:i",
                        defaultDate: defaultDateValue,
                        minDate: `${data_date.min_length_reservation}`,
                        maxDate: `${data_date.max_length_reservation}`,
                        disable: data_date.disabled_date,
                        disableMobile: "true",
                        minuteIncrement: 15,
                        locale: Spanish,
                        onValueUpdate: function (selectedDates, oldDate) {
                            console.log(oldDate);
                        },
                        onChange: function (selectedDates, dateStr, instance) {
                            console.log('DateTo onChange:', dateStr);
                            //
                            // // Usar requestAnimationFrame para evitar múltiples llamadas
                            requestAnimationFrame(() => {
                                context.checkFieldValue('dateTo');
                            });
                        }
                    });

                    // Usar requestAnimationFrame para la verificación inicial
                    requestAnimationFrame(() => {
                        context.checkFieldValue('dateTo');
                    });

                } else {
                    toastr.error(data.message);
                }
            })
        })
    }

    disabled(e) {
        if (e.target.checked) {
            if (e.target.dataset.target === 'drop_office') {
                $(this.dropOfficeTarget).removeAttr('disabled')
            } else {
                $(e.target.dataset.target).removeAttr('disabled')
            }
        } else {
            if (e.target.dataset.target === 'drop_office') {
                $(this.dropOfficeTarget).val(e.target.dataset.default).trigger({
                    type: 'change.select2'
                })
                    .prop('disabled', true);
            } else {
                $(e.target.dataset.target).prop('disabled', true)
            }
        }
    }

    getProducts() {
        // Verificar que todos los targets existen
        if (!this.hasAgencyTarget || !this.hasOfficeTarget || !this.hasDropOfficeTarget ||
            !this.hasDateFromTarget || !this.hasDateToTarget) {
            console.log('No todos los targets están disponibles');
            return;
        }

        // Obtener valores asegurando que no sean null/undefined
        let agency = this.getSelectValue(this.agencyTarget);
        let office = this.getSelectValue(this.officeTarget);
        let office_drop = this.getSelectValue(this.dropOfficeTarget);
        let from_date = this.dateFromTarget.value;
        let to_date = this.dateToTarget.value;

        // Validar valores
        if (!this.validateValues(agency, office, office_drop, from_date, to_date)) {
            return;
        }

        // Verificar si realmente necesitamos ejecutar (valores diferentes a la última ejecución)
        const currentValues = `${agency}_${office}_${office_drop}_${from_date}_${to_date}`;
        if (this.lastExecutedValues === currentValues) {
            console.log('Los valores no han cambiado desde la última ejecución, ignorando...');
            return;
        }else{
            let vehicles_area = $('#vehicles_area');
            if(vehicles_area){
                vehicles_area.html(`
                    <div class="d-flex justify-content-center align-items-center" style="height: 100%;font-size: 2rem;background-color: rgba(0,0,0,.3); border-radius: 10px;">
                        <span class="d-flex flex-column">
                          <span>
                             <span class="fa fa-spin fa-circle-o-notch"></span>
                             <span>Buscando categorías....</span>
                          </span>
                        </span>
                      </div>
                `)

            }
        }

        console.log('🚀 Ejecutando getProducts con:', {
            agency, office, office_drop, from_date, to_date
        });

        this.lastExecutedValues = currentValues;

        // Cancelar petición anterior si existe
        if (this.productsRequest) {
            this.productsController.abort();
        }

        this.productsController = new AbortController();

        this.productsRequest = get(`/admin/get_products_b2c`, {
            query: {
                agency: agency,
                office: office,
                office_drop: office_drop,
                from_date: from_date,
                to_date: to_date,
                vehicle_area: 'vehicles_area',
                form_area: 'form_area'
            },
            responseKind: "turbo-stream"
        }).then(response => {
            if (response.ok) {
                console.log('getProducts ejecutado correctamente');
            } else {
                console.log('Error en getProducts:', response.status);
            }
        }).catch(error => {
            if (error.name !== 'AbortError') {
                console.error('❌ Error en getProducts:', error);
            }
        });
    }


    // Método de utilidad para depuración
    logFormStatus() {
        console.log('=== ESTADO DEL FORMULARIO ===');
        Object.entries(this.requiredFields).forEach(([field, isComplete]) => {
            const value = this[`${field}Target`]?.value || 'sin valor';
            console.log(`${field}: ${isComplete ? '✓' : '✗'} (${value})`);
        });
        console.log('=============================');
    }

    // Cleanup de observers cuando se destruye el controlador
    disconnect() {
        if (this.observers) {
            Object.values(this.observers).forEach(observer => {
                if (observer && observer.disconnect) {
                    observer.disconnect();
                }
            });
        }
    }


}